import { useNavigate, useLocation } from "react-router-dom";
import { Sparkles, Search, MessageCircle, PlusCircle, LayoutDashboard } from "lucide-react";

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const items = [
    { key: "discover", label: "Discover", icon: Sparkles, to: "/discover", match: (p) => p.startsWith("/discover") },
    { key: "search", label: "Search", icon: Search, to: "/", match: (p) => p === "/" || p.startsWith("/properties") },
    { key: "post", label: "Post", icon: PlusCircle, to: "/post", match: (p) => p.startsWith("/post") },
    { key: "chats", label: "Chats", icon: MessageCircle, to: "/chats", match: (p) => p.startsWith("/chats") },
    { key: "account", label: "Account", icon: LayoutDashboard, to: "/dashboard", match: (p) => p.startsWith("/dashboard") },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-[60] bg-white/95 backdrop-blur border-t border-slate-200 pb-[env(safe-area-inset-bottom)]" data-testid="bottom-nav">
      <div className="grid grid-cols-4">
        {items.map((it) => {
          const active = it.match(location.pathname);
          return (
            <button
              key={it.key}
              data-testid={`bottomnav-${it.key}`}
              onClick={() => navigate(it.to)}
              className={`flex flex-col items-center gap-1 py-2.5 transition-colors ${active ? "text-navy" : "text-slate-400"}`}
            >
              <it.icon className={`h-5 w-5 ${active ? "text-navy" : "text-slate-400"}`} />
              <span className="text-[11px] font-medium">{it.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
